import { getSchoolClassVariant } from "~/utils/getSchoolClassVariant";

export const getBadgeVariant = (value: string) => {
  const classVariant = getSchoolClassVariant(value);
  if (classVariant) return classVariant;

  if (value.toLowerCase().includes("polski")) return "polish";
  if (value.toLowerCase().includes("matematyka")) return "math";
  if (value.toLowerCase().includes("angielski")) return "english";

  return undefined;
};
